import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import ProgrammeApi from '../server/ProgrammeApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);


export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_LIST);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_LIST_ERROR);

        // get all notifications from the server
        return ProgrammeApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_INFO);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_INFO_ERROR);

        return ProgrammeApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_INFO_ERROR);
        
        return ProgrammeApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_UPDATE_ERROR);
        
        return ProgrammeApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_DELETE);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_DELETE_ERROR);
        
        return ProgrammeApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText) {
        const handleSuccess = createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED);
        const handleError = createErrorHandler(ActionTypes.SEARCH_ERROR);
        
        return ProgrammeApi.search(searchText)
            .then(handleSuccess, handleError);
    },
    
    getCourses: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_COURSE_LIST);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_COURSE_LIST_ERROR);

        return ProgrammeApi.getCourses(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    
    addCourse: function(id, courseId) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_COURSE_SAVE);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_COURSE_SAVE_ERROR);

        return ProgrammeApi.addCourse(id, courseId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
    
    removeCourse: function(id, courseId) {
        const handleSuccess = createSuccessHandler(ActionTypes.PROGRAMME_COURSE_DELETE);
        const handleError = createErrorHandler(ActionTypes.PROGRAMME_COURSE_DELETE_ERROR);

        return ProgrammeApi.removeCourse(id, courseId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },
};
